import {
  ServiceRequestFormContextValue,
  useServiceRequestFormContext,
} from 'src/components/ServiceRequestForm/CustomHooks/ServiceRequestFormContext';
import { ServiceRequestFormStep } from 'src/components/ServiceRequestForm/CustomHooks/serviceRequestFormSteps';
import {
  UseServiceRequestReferenceDataReturn
} from 'src/components/ServiceRequestForm/CustomHooks/useServiceRequestReferenceData';

export interface UseServiceRequestFormCategoryOrchestratorReturn {
  diagnosisAsset: string;
  diagnosisIssueType: string;
  warrantyExpiresAt: string;
  visibleCategories: any[];
  onSelectCategory: (category: any) => void;
  onSkipToDetails: () => void;
  onBack: () => void;
  onExit: () => void;
}

export const useServiceRequestFormCategoryOrchestrator =
  (): UseServiceRequestFormCategoryOrchestratorReturn => {
    const {
      formData,
      patchFormData,
      goNext,
      goPrev,
      goToStep,
      user,
      onExit,
      reference,
    }: ServiceRequestFormContextValue = useServiceRequestFormContext();

    const { faqs, getFaqsForIssueType }: UseServiceRequestReferenceDataReturn =
      reference;

    const isHomeOwner: boolean = user?.roles?.[0]?.role?.name === 'Home Owner';

    const homeOwnerCategories: any[] = faqs;

    const issueTypeCategories: any[] = getFaqsForIssueType(formData.issueType);

    const visibleCategories: any[] = isHomeOwner
      ? homeOwnerCategories
      : issueTypeCategories;

    const onSelectCategory = (category: any): void => {
      patchFormData({ category });
      goNext();
    };

    const onSkipToDetails = (): void => {
      goToStep(ServiceRequestFormStep.Details);
    };

    const onBack = (): void => {
      goPrev();
    };

    return {
      diagnosisAsset: formData.asset_item_nameDescription,
      diagnosisIssueType: formData.issueType,
      warrantyExpiresAt: formData.assetWarrantyExpiresAt,
      visibleCategories,
      onSelectCategory,
      onSkipToDetails,
      onBack,
      onExit,
    };
  };